import React, { useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import images from '_images';
import HOC from '_HOC';

import { config as configSetup } from '_actions';

const ContentBox = styled.div`
  transition: all 0.5s ease-out;
  max-height: 1000px;
  background-color: #ffffff;
  position: relative;
`;

const CustomHtmlContainer = styled.div`
    position: relative;
    padding: 15px 20px;
    background-color: #ffffff;
    height: auto;
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
    transition: all 0.5s ease-out;
`;

const Content = styled.div`
    line-height: 1.25em;
    text-align: justify;
    background-color: #72888E;
    color: #fff;
    padding: 30px 35px;
    border-radius: 10px;
    position: relative;
    font-weight: 500;
    transition: all 0.5s ease-out;
`;

const CloseButton = styled.button`
    position: absolute;
    top: 24px;
    right: 30px;
    cursor: pointer;
    background-image: url(${images.closeIconWhite});
    background-repeat: no-repeat;
    background-size: 60%;
    background-position: center;
    z-index: 9;
    background-color: transparent;
    border: none;
    margin: 0;
    padding: 0;
    height: 30px;
    transition: all 0.5s ease-out;

    &:focus {
      outline: none;
    }
`;

const InnerCloseButton = styled.span`
    padding: 15px 15px;
    box-sizing: border-box;
    display: inline-block;
    position: relative;
    transition: all 0.5s ease-out;

    ${CloseButton}:focus > & {
      box-shadow: 0 0 2px 2px #51a7e8;
      border-radius: 5px;
    }

    &:focus {
      outline: none;
    }
`;

/**
 * This component is for showing the prompt message
 *
 * @author Alireza Zebardast
 * @param {object} config
 */
const PromptMessage = ({ config, setIsPromptMessageOpen }) => {
  const { webappConfig } = config;
  const { prompt_message: promptMessage } = webappConfig || { prompt_message: '' };

  const [heightSize, setHeightSize] = useState('');
  const [paddingSize, setPaddingSize] = useState('15px 20px');

  const closeCustomBanner = () => {
    setHeightSize('0px');
    setPaddingSize('0 20px');
    setIsPromptMessageOpen(false);
  };

  return (
    <ContentBox style={{ maxHeight: heightSize }}>
      <CloseButton tabIndex="0" onClick={closeCustomBanner}>
        <InnerCloseButton tabIndex="-1" />
      </CloseButton>
      <CustomHtmlContainer style={{ maxHeight: heightSize, padding: paddingSize }}>
        <Content dangerouslySetInnerHTML={{ __html: promptMessage }} />
      </CustomHtmlContainer>
    </ContentBox>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setIsPromptMessageOpen: (isOpen) => dispatch(configSetup.setIsPromptMessageOpen(isOpen)),
});

export default HOC(connect(null, mapDispatchToProps)(PromptMessage));
